<template>
    <div class="login-form" :class="{ 'active' : isLoginFormOpen }">
        <div class="login-form_title">
            Авторизация <a href="javascript:void(0)" class="login-form_close" @click="close"></a>
        </div>
        <div class="login-form_list" v-if="!fio">
            <div class="login_form_item" >
                <p>&nbsp;</p>
            </div>

            <div class="login_form_item bootstrap" >
                <div class="col">
                    <input type="email" v-model="formParams.username" placeholder="введите email" class="form-control"/>
                    <input type="password" v-model="formParams.password" placeholder="введите пароль" class="form-control"/>
                    <p class="text-center">
                        <a href="/remember-password-form">Забыли пароль?</a>
                    </p>
                </div>
            </div>
            <div class="login-form_result">
                <div class="login-form_result_buts">
                    <a href="javascript:void(0)" class="btn btn-orange" @click="auth()">  Войти </a>
                    <a href="/registration-form" class="btn btn-gray"> Регистрация </a>
                </div>
            </div>
        </div>
        <div class="login-form_list" v-else>
            <div class="login_form_item" >
                <div class="spacer"></div>
                <h2 class="font-size-120 text-center">Вы вошли как <span class="text-bold text-orange">{{ fio }}</span></h2>
            </div>
            <div class="login-form_result">
                <div class="login-form_result_buts">
                    <a href="/customer/private/orders" class="btn btn-orange w100"> Перейти в ЛК </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "LoginFormFloat",
        props: ['fio'],
        data() {
          return {
              formParams: {}
          }
        },
        computed: {
           isLoginFormOpen () {
               return this.$store.state.isLoginFormOpen

           }
        },
        methods: {
            close() {
                this.$store.state.isLoginFormOpen=false
            },
            auth() {
                this.$http.post('/login', this.formParams).then( response => {
                    const userData = response.data
                    if(userData.username){
                        window.location.href = '/customer/private/orders';
                    }else{
                        this.$modal.show('dialog', {
                            title: 'Ошибка авторизации',
                            text: 'Неверный логин или пароль.',
                            buttons: [
                                {
                                    title: 'Закрыть'
                                }
                            ]
                        })
                    }
                }, error => {
                    error
                    this.$modal.show('dialog', {
                        title: 'Ошибка авторизации',
                        text: 'Неверный логин или пароль.',
                        buttons: [
                            {
                                title: 'Закрыть'
                            }
                        ]
                    })
                })
            }

        }
    }
</script>

<style scoped>

</style>